import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { uerActKC2OtherTotalsGql } from '../../workOrderQueries';

const requestId = 'uerActKC2OtherTotals';

export const useUerActKC2OtherTotals = (actKC2Id?: number, getActKC2TotalOnly?: boolean) => {
    const [uerActKC2OtherTotalsReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => {
        const where = getActKC2TotalOnly
            ? {
                  isActKC2Total: { eq: true },
              }
            : undefined;

        return { actKC2Id, where };
    }, [actKC2Id, getActKC2TotalOnly]);

    const [uerActKC2OtherTotalsData, uerActKC2OtherTotalsStatus] = useRequest({
        requestId,
        query: uerActKC2OtherTotalsGql,
        variables,
        withEffect: !!actKC2Id,
    });

    useEffect(() => {
        uerActKC2OtherTotalsReset(undefined);
    }, [uerActKC2OtherTotalsReset]);

    const items = useMemo(
        () => uerActKC2OtherTotalsData?.uerActKC2OtherTotals?.items || [],
        [uerActKC2OtherTotalsData?.uerActKC2OtherTotals?.items],
    );

    return {
        items,
        status: uerActKC2OtherTotalsStatus,
    };
};
